export const OPERATIONS = {
  FREEZE: 'FREEZE',
  EDIT: 'EDIT',
};
